import { render, staticRenderFns } from "./CertificationSection.vue?vue&type=template&id=df719c00&scoped=true"
import script from "./CertificationSection.vue?vue&type=script&lang=js"
export * from "./CertificationSection.vue?vue&type=script&lang=js"
import style0 from "./CertificationSection.vue?vue&type=style&index=0&id=df719c00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df719c00",
  null
  
)

export default component.exports